import { ToggleGroup } from '@ps/isp-web-component-library';
import { LiveData as LiveDataIcon } from '@ps/isp-web-component-library/icons/LiveData';
import { LiveStreaming as LiveStreamIcon } from '@ps/isp-web-component-library/icons/LiveStreaming';
import { Stats as StatsIcon } from '@ps/isp-web-component-library/icons/Stats';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { LiveOption } from '@swf/sports/types/liveOption';

import { TXTACL_Stats, TXTWCL_Live_Data, TXTWCL_Live_Stream } from './LiveOptions.messages.json';

interface LiveOptionsProps {
  handleToggleGroupChange: (value: LiveOption) => void;
  hasLiveDataAvailable?: boolean;
  hasLiveStreamAvailable?: boolean;
  variant?: 'standard' | 'plain';
  liveDataIcon?: typeof LiveDataIcon;
  liveStreamIcon?: typeof LiveStreamIcon;
  hasTeamStatsAvailable?: boolean;
}

const LiveOptions: React.FC<LiveOptionsProps> = ({
  handleToggleGroupChange,
  hasLiveDataAvailable,
  hasLiveStreamAvailable,
  hasTeamStatsAvailable = false,
  variant,
  liveDataIcon,
  liveStreamIcon
}) => {
  const { formatMessage } = useRegulatoryIntl();

  const handleChange = (value: string) => {
    if (!value || Object.values(LiveOption).includes(value as LiveOption)) {
      handleToggleGroupChange(value as LiveOption);
    }
  };

  return hasLiveDataAvailable || hasLiveStreamAvailable || hasTeamStatsAvailable ? (
    <ToggleGroup onChange={handleChange} variant={variant}>
      {hasLiveDataAvailable ? (
        <ToggleGroup.Item
          icon={liveDataIcon || LiveDataIcon}
          label={formatMessage(TXTWCL_Live_Data)}
          value={LiveOption.LIVE_DATA}
        />
      ) : null}
      {hasLiveStreamAvailable ? (
        <ToggleGroup.Item
          icon={liveStreamIcon || LiveStreamIcon}
          label={formatMessage(TXTWCL_Live_Stream)}
          value={LiveOption.LIVE_STREAM}
        />
      ) : null}
      {hasTeamStatsAvailable ? (
        <ToggleGroup.Item
          icon={StatsIcon}
          label={formatMessage(TXTACL_Stats)}
          value={LiveOption.TEAM_STATS}
        />
      ) : null}
    </ToggleGroup>
  ) : null;
};

export default LiveOptions;
